/* eslint-disable react-native/no-inline-styles */
import {Input, Text, Icon} from '@ui-kitten/components';
import React from 'react';
import {
  Image,
  Platform,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
  Text as TextRN,
  TouchableOpacity,
} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  AUTHENTICATED_ROUTES,
  UN_AUTHENTICATED_ROUTES,
} from '../../../navigation/constants';
import {signIn} from '../../../redux/actions';
import {px} from '../../../utils';
import {renderIf} from '../../../utils/Utils';
import AppBaseScreen from '../../common/AppBaseScreen';
import AppButton from '../../common/AppButton';
// import moment from 'moment';
import storage from '@react-native-async-storage/async-storage';
import {starBanner} from '../../../assets/images';
import {getUniqueId, getVersion} from 'react-native-device-info';
// import Publicip from 'react-native-public-ip';
class SignInScreen extends AppBaseScreen {
  state = {
    email_id: '',
    password: '',
    loading: false,
    secureTextEntry: true,
    errorMessage: '',
  };

  onSignup = () => {
    const {navigation} = this.props;
    navigation.push(UN_AUTHENTICATED_ROUTES.signUp.path);
  };

  onForgotPassword = () => {
    const {navigation} = this.props;
    navigation.push(UN_AUTHENTICATED_ROUTES.forgotPassword.path);
  };

  onChange = (key, value) => {
    this.setState({[key]: value});
  };

  toggleSecureEntry = () => {
    this.setState({secureTextEntry: !this.state.secureTextEntry});
  };

  onLoginSuccess = () => {
    this.setState({loading: false});
    this.props.navigation.push(AUTHENTICATED_ROUTES.main.path);
  };

  onLoginFailed = (mes) => {
    this.setState({loading: false});
    this.setState({errorMessage: mes});
  };

  onLogin = async () => {
    this.setState({errorMessage: ''});
    if (this.state.email_id === '' || this.state.password === '') {
      this.setState({errorMessage: 'Email and password cannot be empty!'});
    } else {
      this.setState({loading: true});
      var {email_id, password} = this.state;
      email_id = email_id.toLowerCase();

      let deviceInfo = {};
      let deviceData = {};
      if (Platform.OS === 'android' || Platform.OS === 'ios') {
        deviceInfo = {
          deviceId: getUniqueId(),
          deviceType: Platform.OS,
          fcm: await storage.getItem('fcm_token'),
        };
      }
      // deviceData = {
      //   deviceType: Platform.OS,
      //   login_ip: await Publicip(),
      // };
      deviceData = {
        deviceType: Platform.OS,
        login_ip: '',
      };
      this.props.login(
        {
          email_id: email_id,
          password: password,
          deviceInfo: deviceInfo,
          deviceData: deviceData,
        },
        this.onLoginSuccess,
        this.onLoginFailed,
      );
    }
  };

  render() {
    const {loading, secureTextEntry} = this.state;
    const appVersion = getVersion();

    return (
      <KeyboardAwareScrollView style={styles.keyboardContainer}>
        <View style={styles.formContainer}>
          <View>
            <View
              style={{
                justifyContent: 'center',
                flexDirection: 'row',
                marginTop: px(30),
                marginBottom: px(20),
              }}>
              <Image
                source={starBanner}
                resizeMode="contain"
                style={styles.image}
              />
            </View>

            <TextRN style={styles.headingText}>Login to your account</TextRN>

            {renderIf(
              this.state.errorMessage,
              <View style={styles.errorText}>
                <Text status="danger">{this.state.errorMessage}</Text>
              </View>,
            )}
            <Input
              keyboardType="email-address"
              label="Email address"
              size="large"
              autoCompleteType="email"
              value={this.state.email_id}
              onChangeText={(text) => this.onChange('email_id', text)}
            />
            <Input
              style={styles.passwordInput}
              accessoryRight={() => (
                <TouchableWithoutFeedback onPress={this.toggleSecureEntry}>
                  <Icon
                    {...this.props}
                    size={18}
                    style={{width: px(24)}}
                    name={secureTextEntry ? 'eye-off' : 'eye'}
                  />
                </TouchableWithoutFeedback>
              )}
              secureTextEntry={secureTextEntry}
              label="Password"
              size="large"
              autoCompleteType="password"
              value={this.state.password}
              onChangeText={(text) => this.onChange('password', text)}
            />
            <TouchableOpacity onPress={this.onForgotPassword}>
              <Text style={styles.forgotText} status="primary">
                {'Forgot your password?'}
              </Text>
            </TouchableOpacity>
          </View>
          <View>
            <AppButton
              title="Login"
              status="primary"
              size="large"
              appearance="filled"
              onPress={this.onLogin}
              loader={true}
              loading={loading}
              style={styles.loginButton}
            />
            <View style={styles.signUpContainer}>
              <Text status="basic">{"Don't have an account?"}</Text>
              <TouchableOpacity onPress={this.onSignup}>
                <Text status="primary">{' Signup'}</Text>
              </TouchableOpacity>
            </View>

            {Platform.OS !== 'web' && (
              <Text style={styles.versionText}>{`v ${appVersion}`}</Text>
            )}
          </View>
        </View>
      </KeyboardAwareScrollView>
    );
  }
}

const styles = StyleSheet.create({
  keyboardContainer: {
    flex: 1,
    backgroundColor: '#FFF',
  },
  container: {
    backgroundColor: '#FFF',
    flex: 1,
    alignItems: 'center',
  },
  signInContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 24,
  },
  socialAuthContainer: {
    marginTop: 48,
  },
  btnSignUp: {
    fontWeight: '700',
  },
  headingText: {
    textAlign: 'center',
    fontWeight: '600',
    fontSize: 26,
    marginVertical: 20,
  },
  forgotText: {},
  loginButton: {
    marginTop: px(20),
  },
  signUpContainer: {
    flexDirection: 'row',
    marginTop: px(15),
    justifyContent: 'center',
  },
  formContainer: {
    backgroundColor: '#FFF',
    flex: 1,
    paddingTop: 10,
    paddingHorizontal: 20,
    color: '#000',
    paddingBottom: 30,
    //justifyContent: 'space-between',
    width: '100%',
  },
  passwordInput: {
    marginTop: 16,
    marginBottom: 10,
  },
  image: {
    width: px(200),
    height: px(200),
  },
  signUpButton: {
    flexDirection: 'row-reverse',
    paddingHorizontal: 0,
  },
  socialAuthButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  socialAuthHintText: {
    alignSelf: 'center',
    marginBottom: 16,
  },
  errorText: {
    borderColor: 'red',
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    paddingHorizontal: px(15),
    paddingVertical: px(10),
    marginBottom: px(15),
  },
  versionText: {
    marginTop: 20,
    fontSize: px(12),
    width: '100%',
    textAlign: 'center',
  },
});

const mapDispatchToProps = (dispatch) => ({
  login: bindActionCreators(signIn, dispatch),
});

export default connect(null, mapDispatchToProps)(SignInScreen);
